var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.loadPriceStatus
    }
  }), _c('sign-in-dialog', {
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), !_vm.hideSignOut ? _c('div', {
    staticClass: "d-flex flex-column align-end mb-12 mx-n3 overflow-auto"
  }, [_c('v-btn', {
    staticStyle: {
      "text-transform": "none"
    },
    attrs: {
      "small": "",
      "text": "",
      "color": _vm.isSignedIn ? 'secondary' : 'error',
      "disabled": _vm.disableSignOut
    },
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.isSignedIn ? _vm.mdiAccountCheck : _vm.mdiAccount)
    }
  }), _vm._v(" " + _vm._s(_vm.isSignedIn ? _vm.global.profile.email : 'Sign in') + " ")], 1)], 1) : _vm._e(), _vm.itemized ? [_c('itemized-price', {
    staticClass: "mb-12",
    attrs: {
      "itemized": _vm.itemized
    }
  }), !_vm.isSignedIn ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "text-body-2 mb-3"
  }, [_vm._v("Please sign in / create account to continue")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showSignIn = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAccount)
    }
  }), _vm._v(" Sign in ")], 1)], 1) : _vm._e(), _c('payment-btns', {
    staticClass: "mx-auto",
    style: {
      height: _vm.isSignedIn ? null : '0',
      overflow: _vm.isSignedIn ? null : 'hidden'
    },
    attrs: {
      "itemized": _vm.itemized,
      "metadata": _vm.metadata,
      "loading": _vm.isPaymentBtnsLoading,
      "progress": _vm.isPaymentInProgress,
      "is-promo-intercept-visible": _vm.isPromoInterceptVisible
    },
    on: {
      "update:loading": function ($event) {
        _vm.isPaymentBtnsLoading = $event;
      },
      "update:progress": function ($event) {
        _vm.isPaymentInProgress = $event;
      },
      "update:isPromoInterceptVisible": function ($event) {
        _vm.isPromoInterceptVisible = $event;
      },
      "update:is-promo-intercept-visible": function ($event) {
        _vm.isPromoInterceptVisible = $event;
      },
      "price-update": _vm.onPriceUpdate,
      "complete": _vm.onComplete,
      "purchase-subscription": function ($event) {
        _vm.loadPrice();

        _vm.$emit('purchase-subscription');
      }
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }